import Head from 'next/head';

const site = 'https://afivio.com';
export default function ShopifySEO({
  title,
  description,
  path,
  article = false,
  locale = 'en',
  alternatePaths,
  breadcrumb
}) {
  const url = `${site}${path}`;
  const alternates = alternatePaths || { en: path };
  const breadcrumbs = [
    {
      '@type': 'ListItem',
      position: 1,
      name: breadcrumb?.home || 'Home',
      item: site
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: breadcrumb?.hub || 'Shopify guides and tools',
      item: `${site}${breadcrumb?.hubPath || '/shopify-guides'}`
    },
    ...(article
      ? [{ '@type': 'ListItem', position: 3, name: title, item: url }]
      : [])
  ];
  const graph = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': article ? 'Article' : 'CollectionPage',
        '@id': `${url}#content`,
        url,
        headline: title,
        name: title,
        description,
        inLanguage: locale,
        ...(article
          ? {
              author: { '@type': 'Organization', name: 'Afivio', url: site },
              mainEntityOfPage: url
            }
          : {}),
        publisher: { '@type': 'Organization', name: 'Afivio', url: site },
        image: `${site}/og.png`
      },
      { '@type': 'BreadcrumbList', itemListElement: breadcrumbs }
    ]
  };
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} key="description" />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={url} />
      {Object.entries(alternates).map(([alternateLocale, alternatePath]) => (
        <link
          key={alternateLocale}
          rel="alternate"
          hrefLang={alternateLocale}
          href={`${site}${alternatePath}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${site}${alternates.en}`}
      />
      <meta property="og:type" content={article ? 'article' : 'website'} />
      <meta property="og:site_name" content="Afivio" />
      <meta
        property="og:locale"
        content={{ en: 'en_US', pl: 'pl_PL', uk: 'uk_UA' }[locale] || 'en_US'}
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${site}/og.png`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${site}/og.png`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(graph).replace(/</g, '\\u003c')
        }}
      />
    </Head>
  );
}
